<div
  class="alert-card"
  [ngClass]="{
    active: selectedInterventionId === interventionLog.interventionId,
  }"
  [class.status-unread]="isUnreadIndicator"
  (click)="
    onCardClick(interventionLog.rigJournalId, interventionLog.interventionId)
  ">
  <div class="alert-card__head">
    <div class="alert-card__name-wrap">
      @if (isUnreadIndicator) {
        <div class="alert-card__unread-dot" aria-label="Unread alert"></div>
      }
      <span
        class="alert-card__name"
        [pTooltip]="interventionLog.wellName"
        tooltipPosition="bottom"
        appendTo="body">
        {{ collapseName(interventionLog.wellName) }}
      </span>
    </div>

    <div
      class="alert-card__status"
      [ngClass]="statusPillClass"
      [pTooltip]="statusTextHover"
      tooltipPosition="bottom"
      tooltipStyleClass="alert-status-tooltip"
      appendTo="body">
      @switch (statusIconKey) {
        @case ('complete') {
          <svg-icon class="custom-svg-icon" key="complete" size="md"></svg-icon>
        }
        @case ('required') {
          <svg-icon class="custom-svg-icon" key="required" size="md"></svg-icon>
        }
        @case ('readEnvelope') {
          <svg-icon
            class="custom-svg-icon"
            key="readEnvelope"
            size="md"></svg-icon>
        }
        @default {
          <svg-icon
            class="custom-svg-icon"
            key="unReadEnvelope"
            size="md"></svg-icon>
        }
      }
      <p class="alert-card__status-text">{{ statusPillText }}</p>
    </div>
  </div>

  <div class="alert-card__created">Created: {{ shortTimeHHMM }}</div>

  <div class="alert-card__category">
    @for (event of eventHierarchy; track event; let isFirst = $first) {
      @if (!isFirst) {
        <span class="alert-card__sep">/</span>
      }
      <span>{{ event?.trim() }}</span>
    }
  </div>

  <div class="alert-card__desc">
    <p
      [pTooltip]="interventionLog.description | removeHtmlTags"
      tooltipPosition="bottom"
      tooltipStyleClass="custom-tooltip"
      appendTo="body">
      {{ interventionLog.description | removeHtmlTags }}
    </p>
  </div>

  <div class="alert-card__meta">
    @if (interventionLog.country) {
      <span
        class="alert-card__meta-item"
        [pTooltip]="interventionLog.country + ' - ' + interventionLog.region"
        tooltipPosition="bottom"
        appendTo="body">
        <strong>Country:</strong>
        {{ interventionLog.region || interventionLog.country }}
      </span>
    }

    <span
      class="alert-card__meta-item"
      [pTooltip]="interventionLog.operatorName"
      tooltipPosition="bottom"
      appendTo="body">
      <strong>Customer:</strong>
      {{ collapseName(interventionLog.operatorName) || 'N/A' }}
    </span>

    <span
      class="alert-card__meta-item"
      [pTooltip]="interventionLog.rigName"
      tooltipPosition="bottom"
      appendTo="body">
      <strong>Rig:</strong>
      {{ collapseName(interventionLog.rigName) || 'Rig Name' }}
    </span>

    <span
      class="alert-card__meta-item"
      [pTooltip]="interventionLog.projectName"
      tooltipPosition="bottom"
      appendTo="body">
      <strong>Project:</strong>
      {{ collapseName(interventionLog.projectName) || 'Project Name' }}
    </span>
  </div>
</div>
